import { safeCall } from '@/app/utils/safeCall';

export const playVideoWithPromiseHandle = (
  video: HTMLVideoElement,
  onSuccess?: () => void,
  onRejected?: (error: unknown) => void
): Promise<void> => {
  if (!video) return Promise.resolve();

  return video.play().then(
    () => {
      // NOTE: auto-play started
      safeCall(onSuccess);
    },
    (error: unknown) => {
      // NOTE: auto-play was prevented
      safeCall(onRejected, error);
    }
  );
};

export const youtubeEmbedURL = (youtubeId: string, muted = false) => {
  if (youtubeId === '') return '';
  return `https://www.youtube.com/embed/${youtubeId}/?autoplay=1&rel=0&modestbranding=1&mute=${muted ? 1 : 0}`;
};

export const youtubeURL = (youtubeId: string) => {
  if (youtubeId === '') return '';
  return `https://www.youtube.com/watch?v=${youtubeId}`;
};
